import { createFileRoute } from '@tanstack/react-router'
import { DashboardServers } from '@/pages/DashboardServers'

export const Route = createFileRoute('/$orgId/dashboard/servers/')({
  component: DashboardServers,
  meta: () => [{ title: 'Servers' }],
})
